import React from 'react';
import '../../styles/syllabus/main.css';
import { Link } from 'react-router-dom';

const Main = () => {
    return (
        <div id="mainSyllabus">
            <div className="container">
                <h2 className="text-left my-heading">Syllabus</h2>
                <div className="main-div">
                    <div className="left-main-box">
                        <div className="text-center my-heading pt-3" style={{ fontSize: 14 }}>
                            Syllabus for all except of NEP-2020
                        </div>
                        <div className="boxes">
                            <div className="box">
                                <img src="assets/images/syllabus/open-book-blue.png" alt="Open Book Icon" />
                                <div className="horizon-line" />
                                <h6>CAMPUS SYLLABUS</h6>
                                <Link className="normal-button" to="/campus-syllabus">
                                    View
                                </Link>
                            </div>
                            <div className="box">
                                <img src="assets/images/syllabus/open-book-blue.png" alt="Open Book Icon" />
                                <div className="horizon-line" />
                                <h6>COLLEGE SYLLABUS</h6>
                                <Link className="normal-button" to="/college-syllabus">
                                    View
                                </Link>
                            </div>
                            <div className="box">
                                <img src="assets/images/syllabus/open-book-blue.png" alt="Open Book Icon" />
                                <div className="horizon-line" />
                                <h6>CAMPUS SYLLABUS &amp; COLLEGE SYLLABUS (Common)</h6>
                                <Link className="normal-button" to="#">
                                    View
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="right-main-box">
                        <div className="text-center my-heading pt-3" style={{ fontSize: 14 }}>
                            Syllabus B.A./ B.Sc./ B.Com. wef. July 2021
                        </div>
                        <div className="boxes">
                            <div className="box">
                                <img src="assets/images/syllabus/open-book-blue.png" alt="Open Book Icon" />
                                <div className="horizon-line" />
                                <h6>SYLLABUS NEP-2020</h6>
                                <Link className="normal-button" to="/nep-syllabus">
                                    View
                                </Link>
                            </div>
                            <div className="box">
                                <img src="assets/images/syllabus/open-book-blue.png" alt="Open Book Icon" />
                                <div className="horizon-line" />
                                <h6>Skill Development Courses</h6>
                                <Link className="normal-button" to="/skill-development-syllabus">
                                    View
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
